import useOrderAddressRepository from "../../../../../repository/emergency/useOrderAddressRepository";
import {useEffect} from "react";
import {useParams} from "react-router";
import isNull from "../../../../../mixin/isNull";
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useWorkRepository from "../../../../../repository/user/useWorkRepository";
import useOrderRepository from "../../../../../repository/emergency/useOrderRepository";
import useSuggestionRepository from "../../../../../repository/assignment/useSuggestionRepository";
import Map from "./Map";

export default function () {
    const {token} = useParams();
    const suggestionRepository = useSuggestionRepository();
    const orderAddressRepository = useOrderAddressRepository();
    const orderRepository = useOrderRepository();
    const workRepository = useWorkRepository();
    /** @type Suggestion */
    const suggestion = suggestionRepository.findOneByToken(token).select();
    /** @type Order */
    const order = orderRepository.findOneById(suggestion?.getOrderId()).select();
    /** @type OrderAddress */
    const orderAddress = orderAddressRepository.findOneByOrderId(suggestion?.getOrderId()).select();
    /** @type Work */
    const work = workRepository.findOneById(order?.getWorkId()).select();

    useEffect(() => {
        if (isNull(suggestion)) return;

        orderRepository.findOneById(suggestion.getOrderId()).exec();
        orderAddressRepository.findOneByOrderId(suggestion.getOrderId()).exec();
    }, [JSON.stringify(suggestion)]);

    useEffect(() => {
        if (isNull(order)) return;

        workRepository.findOneById(order.getWorkId()).exec();
    }, [JSON.stringify(order)]);


    if (isNull(orderAddress) || isNull(suggestion)) {
        return (
            <Box display="flex" justifyContent={"center"} mt={5}>
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <Box>
            <Typography
                mb={2}
                textAlign={"center"}
                textTransform={"uppercase"}
                fontSize={"small"}
            >
                {orderAddress.getCity()} ({orderAddress.getPostcode()}) : {work?.getName() ?? "loading..."}
            </Typography>
            <Typography
                mt={2}
                fontSize={"small"}
            >
                {order?.getOrderComment()}
            </Typography>
            <Box mt={2}>
                <Map orderId={suggestion.getOrderId()}/>
            </Box>
        </Box>
    )
}